import { BetType, OddsFormat, WinRiskType, RoundRobinOption, SelectionType } from "./Foundation";
import Constants from "./Constants";

export default class BetslipCommon {

  static convertStakeToNumber = (stake) => {
    if (stake) {
      stake = stake.toString().split(',').join('');
    }
    return !isNaN(stake) ? Number(stake) : stake;
  }

  static isFloat = (value) => (
    typeof value === "number" &&
    !Number.isNaN(value) &&
    !Number.isInteger(value)
  );
  

  static formatHandicapNumber = (betType, handicap) => {
    const isInValidType = typeof (handicap) === 'string' || typeof (handicap) === 'undefined' || handicap === null;
    if (isInValidType) {
      return '';
    }
    // do not show hdp point if betType is outright and hdp point is 0
    if ((betType === BetType.OUTRIGHT || betType === BetType.SPECIALS || betType === BetType.THE_1X2) && handicap === 0) {
      return '';
    }

    const handicapScores = BetslipCommon.isFloat(handicap) ? handicap : Number.parseFloat(handicap).toFixed(1);

    if (betType !== BetType.OUTRIGHT &&
      betType !== BetType.SPECIALS &&
      betType !== BetType.OU &&
      betType !== BetType.HOME_TOTALS &&
      betType !== BetType.AWAY_TOTALS) {
      return handicap > 0 ? `+${handicapScores}` : `${handicapScores}`;
    }
    return `${handicapScores}`;
  }

  static getStakeLimit = (winRiskType, winLimit, riskLimit, baseLimit, odds) => {
      let limitVal
      if (winRiskType) {
        switch (winRiskType) {
          case WinRiskType.WIN:
            limitVal =  winLimit
            break
          case WinRiskType.RISK:
            limitVal = riskLimit
            break
          default:
            limitVal = baseLimit
            break
        }
      } else {
        if (odds < 0) {
          limitVal = winLimit
        } else {
          limitVal = riskLimit
        }
      }
      return limitVal
  }

  /**
   * calculate Win from stake
   * @param {*} stake 
   * @param {*} odds 
   * @param {*} ot : odds type
   * @param {*} wrs : win risk stake (WIN, RISK, BASE)
   */
  static calculateToWin = (stake, odds, ot, wrs, betType) => {
    let win = 0;
    ot = betType === BetType.THE_1X2 && (ot === OddsFormat.HK || ot === OddsFormat.MY || ot === OddsFormat.ID) ? OddsFormat.EU : ot
    if (wrs === WinRiskType.WIN) {
      win = stake;
    } else if (wrs === WinRiskType.RISK) {
      win = BetslipCommon.calculateToWinFromRisk(stake, odds, ot);
    } else {
      if (odds > 0) {
        win = BetslipCommon.calculateToWinFromRisk(stake, odds, ot);
      } else {
        win = stake;
      }
    }
    return parseFloat(win);
  }

  /**
   * calculate Risk from stake
   * @param {*} stake 
   * @param {*} odds 
   * @param {*} ot : odds type
   * @param {*} wrs : win risk stake (WIN, RISK, BASE)
   */
  static calculateToRisk = (stake, odds, ot, wrs) => {
    let risk = 0;
    if (wrs === WinRiskType.WIN) {
      risk = BetslipCommon.calculateToRiskFromWin(stake, odds, ot);
    } else if (wrs === WinRiskType.RISK) {
      risk = stake;
    } else {
      if (odds > 0) {
        risk = stake;
      } else {
        risk = BetslipCommon.calculateToRiskFromWin(stake, odds, ot);
      }
    }
    return parseFloat(risk);
  }

  /**
   * Calculate Win from Risk
   * @param {*} riskAmount 
   * @param {*} odds 
   * @param {*} ot : odds type
   */
  static calculateToWinFromRisk = (riskAmountStr, oddsStr, ot) => {
    let win = 0;
    const riskAmount = Number(`${riskAmountStr}`.replaceAll(',', ''))
    const odds = Number(`${oddsStr}`.replaceAll(',', ''))
    switch (Number(ot)) {
      case OddsFormat.American:
        if (odds === 0) {
          win = 0;
        } else if (odds > 0) {
          win = (riskAmount / 100) * odds;
        } else if (odds < 0) {
          win = (riskAmount / Math.abs(odds)) * 100;
        }
        break;
      case OddsFormat.Decimal:
        win = riskAmount * (odds - 1);
        break;
      case OddsFormat.HongKong:
        win = riskAmount * odds;
        break;
      case OddsFormat.Indonesian:
        win = odds === 0 ? 0 : odds > 0 ?
          riskAmount * odds : riskAmount / Math.abs(odds);
        break;
      case OddsFormat.Malay:
        win = odds === 0 ? 0 : odds > 0 ?
          riskAmount * odds : riskAmount / Math.abs(odds);
        break;
      default:
        win = 0;
    }
    return win;
  }

  /**
   * Calculate Risk from Win
   * @param {*} winAmount 
   * @param {*} odds 
   * @param {*} ot : odds type
   */
  static calculateToRiskFromWin = (winAmount, odds, ot) => {
    let risk = 0;
    switch (Number(ot)) {
      case OddsFormat.American:
        if (odds === 0) {
          risk = 0;
        } else if (odds > 0) {
          risk = (winAmount / odds) * 100;
        } else if (odds < 0) {
          risk = (winAmount / 100) * Math.abs(odds);
        }
        break;
      case OddsFormat.Decimal:
        risk = winAmount / (odds - 1);
        break;
      case OddsFormat.HongKong:
        risk = winAmount / odds;
        break;
      case OddsFormat.Indonesian:
        risk = odds === 0 ? 0 : odds > 0 ?
          winAmount / odds : winAmount * Math.abs(odds);
        break;
      case OddsFormat.Malay:
        risk = odds === 0 ? 0 : odds > 0 ?
          winAmount / odds : winAmount * Math.abs(odds);
        break;
      default:
        risk = 0;
    }
    return risk;
  }

  static getMaxpayout = (stake, odds, oddType, betType, winRiskOption) => {
    if (!stake || stake === 0) {
      return 0;
    }
    stake += ''
    stake = Number(stake.replaceAll(Constants.THOUSANDS_SEPARATOR, ''));
    odds = Number(odds);
    let payout = 0;
    let factor = Number(oddType) === OddsFormat.American ? 100 : 1;
    if (OddsFormat.American === Number(oddType)) {
      if (winRiskOption === WinRiskType.WIN) {
        if (odds > 0) {
          payout = stake + (stake / odds * 100);
        } else if (odds < 0) {
          payout = stake + (stake * Math.abs(odds) / 100);
        }
      } else if (winRiskOption === WinRiskType.RISK) {
        if (odds > 0) {
          payout = stake + (stake * odds / 100);
        } else if (odds < 0) {
          payout = stake + (stake / Math.abs(odds) * 100);
        }
      } else {
        payout = (Math.abs(odds) / 100 + 1) * stake;
      }
    } else if (OddsFormat.Decimal === Number(oddType)) {
      payout = BetslipCommon.calculateToWin(stake, odds, oddType, winRiskOption) +
      BetslipCommon.calculateToRisk(stake, odds, oddType, winRiskOption);
    } else {
      if (BetType.THE_1X2 !== betType) {
        if (odds < 0) {
          let isTrue = OddsFormat.Malay === Number(oddType) || OddsFormat.Indonesian === Number(oddType);
          payout = isTrue ? (stake * Math.abs(odds) + stake) : stake * 2;
        } else if (odds < 1) {
          payout = stake * odds + stake;
        } else {
          if (Number(oddType) === OddsFormat.Decimal) {
            payout = stake * odds;
          } else {
            payout = stake * (odds / factor) + stake;
          }
        }
      } else {
        payout = stake * Math.abs(odds);
      }
    }
    return Number(payout);
  }

  
  static getMinWinRiskByOddFormat = (oddsFormat, winRiskOption, bet) => {
    let minLimit
    if (Number(oddsFormat) === OddsFormat.AM || Number(oddsFormat) === OddsFormat.EU) {
      switch (winRiskOption) {
        case WinRiskType.RISK:
          minLimit = bet.minStakeRisk
          break
        case WinRiskType.WIN:
          minLimit = bet.minStakeWin
          break
        default:
          minLimit = bet.minStakeBase
          break
      }
    } else {
      minLimit = bet.minStake
    }
    return minLimit
  }

  static getMinWinRiskByOddFormatRB = (winRiskOption, bet) => {
    let minLimit
    switch (winRiskOption) {
      case WinRiskType.RISK:
        minLimit = bet.minRisk
        break
      case WinRiskType.WIN:
        minLimit = bet.minWin
        break
      default:
        minLimit = bet.minRisk
        break
    }
    return minLimit
  }
  
  static getMaxWinRiskByOddFormat(oddsFormat, winRiskOption, selection) {
    let maxLimit
    if (Number(oddsFormat) === OddsFormat.AM || Number(oddsFormat) === OddsFormat.EU) {
      switch (winRiskOption) {
        case WinRiskType.RISK:
          maxLimit = selection.maxStakeRisk
          break
        case WinRiskType.WIN:
          maxLimit = selection.maxStakeWin
          break
        default:
          maxLimit = selection.maxStakeBase
          break
      }
    } else {
      maxLimit = selection.maxStake;
    }
    return maxLimit
  }

  static getMaxWinRiskByOddFormatRB(winRiskOption, selection) {
    let maxLimit
    switch (winRiskOption) {
      case WinRiskType.RISK:
        maxLimit = selection.maxRisk
        break
      case WinRiskType.WIN:
        maxLimit = selection.maxWin
        break
      default:
        maxLimit = selection.maxRisk
        break
    }
    return maxLimit
  }

  static generateUUID = () => {
    const generate = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return generate() + generate() + '-' + generate() + '-' + generate() + '-' +
      generate() + '-' + generate() + generate() + generate();
  };

  /**
   * calulate to win and max payout base on unround decimal odds
   * @param {*} winriskInfo 
   * @param {*} roundRobin 
   */
  static calculateParlayPayoutByRRO(roundRobin, stake, oddsFormat) {
    let roundRobinOdds;
    let totalStake, totalToWin

    if (RoundRobinOption.PARLAY === roundRobin.roundRobinOption) {
      totalStake = stake;
      totalToWin = BetslipCommon.calculateToWinFromRisk(stake, roundRobin.odds, oddsFormat);
    } else {
      roundRobinOdds = roundRobin.unroundedDecimalOdds
      totalToWin = stake * (roundRobinOdds - 1)
      totalStake = stake * roundRobin.possibleWagers;
    }
    return totalToWin + totalStake;
  }

  static calculateWinRiskInfo = (winriskInfo, roundRobin, stake, oddsFormat) => {
    let totalStake;
    let totalToWin;
    const roundRobinOdds = roundRobin.unroundedDecimalOdds;
    if (RoundRobinOption.PARLAY === roundRobin.roundRobinOption) {
      totalStake = stake;
      totalToWin = roundRobinOdds
        ? stake * (roundRobinOdds - 1)
        : BetslipCommon.calculateToWinFromRisk(stake, roundRobin.odds, oddsFormat);
    } else {
      totalToWin = stake * (roundRobinOdds - 1);
      totalStake = stake * roundRobin.possibleWagers;
    }

    winriskInfo.toWin += totalToWin;
    winriskInfo.totalStake += totalStake;
  
    return winriskInfo;
  }

  static isIntNumber = (n) => {
    return Number(n) === n && n % 1 === 0;
  }

  static formatOddsValue = (price, oddsFormat) => {
    let newFormat = ''
    if (!price) {
      return newFormat
    }
    const convertedPrice = parseFloat(price.toString().replaceAll(Constants.THOUSANDS_SEPARATOR, ''))
    if (convertedPrice) {
        if (OddsFormat.AM === Number(oddsFormat)) {
            newFormat = (convertedPrice > 0 ? '+' : '') + convertedPrice.toFixed(0)
        } else if (OddsFormat.ID === Number(oddsFormat)) {
            // get digits decimal number
            const digits = (price.toString().trim().split('.')[1] || "00").length;
            newFormat = convertedPrice.toDollar(digits, true);
        } else {
            newFormat = convertedPrice.toDollar(3, true)
        }
    }
    return newFormat
  }

  static convertOddsByOddsFormat(oddsValue, currentOddsFormat, newOddsFormat) {
    let standartOdds = parseFloat(BetslipCommon.convertToDecimalOdds(currentOddsFormat, oddsValue));
    let newOdds = 0;
    switch (newOddsFormat) {
      case OddsFormat.American:
        newOdds = BetslipCommon.dec2American(standartOdds)
        break;
      case OddsFormat.HongKong:
        newOdds = BetslipCommon.dec2HK(standartOdds);
        break;
      case OddsFormat.Indonesian:
        newOdds = BetslipCommon.dec2Indo(standartOdds);
        break;
      case OddsFormat.Malay:
        newOdds = BetslipCommon.dec2Malay(standartOdds);
        break;
      default:
        newOdds = standartOdds; // if current odd format is Euro Odds
        break;
    }
    return newOdds;
  }

  static convertOddsProduceNumber(oddsValue, currentOddsFormat, newOddsFormat) {
    let standartOdds = parseFloat(BetslipCommon.convertToDecimalOdds(currentOddsFormat, oddsValue));
    let newOdds = 0;
    switch (newOddsFormat) {
      case OddsFormat.American:
        newOdds = BetslipCommon.dec2American(standartOdds, true)
        break;
      case OddsFormat.HongKong:
        newOdds = BetslipCommon.dec2HK(standartOdds, true);
        break;
      case OddsFormat.Indonesian:
        newOdds = BetslipCommon.dec2Indo(standartOdds, true);
        break;
      case OddsFormat.Malay:
        newOdds = BetslipCommon.dec2Malay(standartOdds, true);
        break;
      default:
        newOdds = standartOdds; // if current odd format is Euro Odds
        break;
    }
    return newOdds;
  }

  static convertToDecimalOdds(oddsFormat, oddsValue) {
    let standardOdds = 0;
    oddsValue = parseFloat(oddsValue);
    switch (oddsFormat) {
      case OddsFormat.American:
        standardOdds = BetslipCommon.american2Dec(oddsValue)
        break;
      case OddsFormat.HongKong:
        standardOdds = BetslipCommon.hk2Dec(oddsValue);
        break;
      case OddsFormat.Indonesian:
        standardOdds = BetslipCommon.id2Dec(oddsValue);
        break;
      case OddsFormat.Malay:
        standardOdds = BetslipCommon.malay2Dec(oddsValue);
        break;
      default:
        standardOdds = oddsValue; // if current odd format is Euro Odds
        break;
    }
    return standardOdds;
  }

   /** CONVERT OTHERS ODDS TO DECIMAL ODDS (EURO ODDS) */
   static american2Dec(amOdds) {
    let convertedPrice;
    convertedPrice = amOdds > 0 ? (amOdds / 100 + 1) : (-100 / amOdds + 1);
    return convertedPrice.toDollar(3, true);
  }

  static hk2Dec(hkOdds) {
    return (hkOdds + 1).toDollar(3, true);
  }

  static malay2Dec(malayOdds) {
    let convertedPrice;
    if (malayOdds > 0) {
      convertedPrice = malayOdds + 1;
    } else {
      let aVal = 1 / malayOdds
      aVal = aVal.toDollar(3, true)
      convertedPrice = 1 - aVal;
    }
    return convertedPrice.toDollar(3, true);
  }

  static id2Dec(idOdds) {
    let convertedPrice;
    if (idOdds >= 0) {
      convertedPrice = idOdds + 1;
    } else {
      convertedPrice = 1 - (1 / idOdds);
    }
    return convertedPrice.toDollar(3, true);
  }

  /** CONVERT DECIMAL ODDS TO OTHERS  */
  static dec2HK(odds, isNumber) {
    let convertedPrice = (odds - 1);
    return isNumber ? convertedPrice : convertedPrice.toDollar(3, true);
  }

  static dec2Indo(odds, isNumber) {
    let convertedPrice;
    if (odds >= 2) {
      convertedPrice = odds - 1;
    } else {
      convertedPrice = 1 / (1 - odds);
    }
    return isNumber ? convertedPrice : convertedPrice.toDollar(3, true);
  }

  static dec2Malay(odds, isNumber) {
    let convertedPrice;
    if (odds <= 2) {
      convertedPrice = odds - 1;
    } else {
      convertedPrice = 1 / (1 - odds);
    }
    return isNumber ? convertedPrice : convertedPrice.toDollar(3, true);
  }

  static dec2American(odds, isNumber) {
    let convertedPrice;
    if (odds > 2) {
      convertedPrice = 100 * (odds - 1);

    } else {
      convertedPrice = -100 / (odds - 1);
    }
    return isNumber ? convertedPrice : convertedPrice.toDollar(3, true);
  }


  static getTeaserSelectionName(homeTeam, awayTeam, selectionType) {
    let selectionName;
    switch (selectionType) {
      case SelectionType.HOME:
        selectionName = homeTeam;
        break;
      case SelectionType.AWAY:
        selectionName = awayTeam;
        break;
      case SelectionType.UNDER:
        selectionName = 'Under';
        break;
      case SelectionType.OVER:
        selectionName = 'Over';
        break;
      default:
      selectionName = '';
    }
    return selectionName;
  }

  static getMinRiskForTeaser(winRiskOption, minRiskStake, minWinStake, odds) {
    let minRisk = 0;
    switch (winRiskOption) {
      case WinRiskType.RISK:
        minRisk = minRiskStake;
        break;
      case WinRiskType.WIN:
        minRisk = minWinStake;
        break;
      default:
        minRisk = parseFloat(odds) > 0 ? minRiskStake : minWinStake;
    }
    return minRisk;
  }

  static getMaxRiskForTeaser(winRiskOption, maxRiskStake, maxWinStake, odds) {
    let maxRisk = 0;
    switch (winRiskOption) {
      case WinRiskType.RISK:
        maxRisk = maxRiskStake;
        break;
      case WinRiskType.WIN:
        maxRisk = maxWinStake;
        break;
      default:
        maxRisk = parseFloat(odds) > 0 ? maxRiskStake : maxWinStake;
    }
    return maxRisk;
  }

  static getRBMinMaxBet(limit) {
    const limitRounded = limit ? limit.toString().split('.')[0] : 0;
    if( Number(limitRounded) === Number(0)) {
      return 0;
    }
    return limit;
  }

  static getPeriodDescription(sportId, periodNum, translate) {
    if (periodNum === 0 && sportId !== Constants.HOCKEY_ID) {
      return translate('FT');
    }
    return translate('periods:periods_' + sportId + '_' + periodNum);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/BetslipCommon.js